/* ============================================================
   YESSKIN · Carrito lateral azul
   Cantidades, quitar, upsells y protección de envío.
   Usa el <cart-drawer> del tema para redibujar (renderContents) y abrir/cerrar.
   ============================================================ */
(function () {
  if (window.__yskCart) return;
  window.__yskCart = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var OFF_KEY = 'ysk-protect-off';

  function drawer() { return document.querySelector('cart-drawer.ysk-drawer'); }
  function panel() { var d = drawer(); return d && d.querySelector('.ysk__panel'); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }

  function busy(on) { var p = panel(); if (p) p.classList.toggle('is-busy', !!on); }

  function post(path, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error');
        return j;
      });
    });
  }

  function render(json) {
    var d = drawer();
    if (!d || !json.sections) return;
    var wasOpen = d.classList.contains('active');
    var body = d.querySelector('[data-ysk-body]');
    var top = body ? body.scrollTop : 0;
    if (typeof d.renderContents === 'function') d.renderContents(json, wasOpen);
    var b2 = d.querySelector('[data-ysk-body]');
    if (b2) b2.scrollTop = top;
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ys-cart', cartData: json }); } catch (e) {}
    }
  }

  function fail(err) {
    busy(false);
    var msg = (err && err.message) || 'No pudimos actualizar el carrito. Probá de nuevo.';
    alert(msg);
  }

  function change(key, qty) {
    busy(true);
    return post('cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(function (j) { render(j); busy(false); })
      .catch(fail);
  }

  function add(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    busy(true);
    return post('cart/add.js', { items: [{ id: parseInt(id, 10), quantity: qty || 1 }] })
      .then(function (j) {
        /* /cart/add.js devuelve solo lo agregado + sections: con eso alcanza para redibujar */
        render(j); busy(false);
      })
      .catch(function (e) { if (btn) btn.classList.remove('is-loading'); fail(e); });
  }

  /* ---------- eventos (delegados: sobreviven a cada redibujado) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('cart-drawer.ysk-drawer')) return;

    var close = t.closest('[data-ysk-close]');
    if (close) { e.preventDefault(); drawer().close(); return; }

    var link = t.closest('[data-ysk-close-link]');
    if (link && link.getAttribute('href') === window.location.pathname) { e.preventDefault(); drawer().close(); return; }

    var q = t.closest('[data-ysk-qty]');
    if (q) { e.preventDefault(); change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10)); return; }

    var a = t.closest('[data-ysk-add]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-ysk-add'), 1, a); return; }
  });

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.matches || !cb.matches('[data-ysk-protect]')) return;
    var p = panel(); if (!p) return;
    var label = cb.closest('.ysk__protect');
    if (label) label.classList.toggle('is-on', cb.checked);
    if (cb.checked) {
      store(OFF_KEY, null);
      add(p.getAttribute('data-protect-variant'), 1);
    } else {
      store(OFF_KEY, '1');
      var key = p.getAttribute('data-protect-key');
      if (key) change(key, 0);
    }
  });

  /* ---------- después de cada redibujado ---------- */
  var syncing = false;
  function afterRender() {
    var d = drawer(), p = panel();
    if (!d || !p || syncing) return;
    var count = parseInt(p.getAttribute('data-count'), 10) || 0;
    var pKey = p.getAttribute('data-protect-key');
    var pVar = p.getAttribute('data-protect-variant');

    /* si solo queda la protección, se quita sola */
    if (count === 0 && pKey) { syncing = true; change(pKey, 0).then(function () { syncing = false; }); return; }

    /* protección automática (opcional desde el editor) */
    if (count > 0 && !pKey && pVar && d.getAttribute('data-ysk-auto-protect') === 'true' && store(OFF_KEY) !== '1') {
      syncing = true; add(pVar, 1).then(function () { syncing = false; });
    }
  }

  function patch(d) {
    if (!d || d.__yskPatched || typeof d.renderContents !== 'function') return;
    d.__yskPatched = true;
    var original = d.renderContents;
    d.renderContents = function (parsed, dontOpen) {
      var wasOpen = d.classList.contains('active');
      var out = original.call(d, parsed, dontOpen);
      var p = panel();
      if (p && wasOpen) p.classList.add('no-anim');
      setTimeout(afterRender, 30);
      return out;
    };
  }

  function init() {
    var d = drawer();
    if (!d) return;
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function () { patch(d); });
    } else { patch(d); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
